// extracted by mini-css-extract-plugin
export default {"button":"Button_button__26Oph","primary":"Button_primary__aVPa1","secondary":"Button_secondary__BsVua","danger":"Button_danger__c4rV5"};